import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const Instapost = () => {
  const [loading, setLoading] = useState(true);
  const [medias, setMedia] = useState([]);

  useEffect(() => {
    fetch('https://graph.instagram.com/9352344184852314/media?fields=id,caption,media_type,media_url,thumbnail_url,permalink,timestamp&access_token=IGAAI65u4zJR5BZAE0tU0NfWWNFQW4tSGtyMUtOWlc0cVZAWLTVEb1ZAYcVpKNUY1cHVNMHZABaXZAzRFBnUFYxMnVkZA2h3ekRRTDlSOURONFhNSjFhaEV6YU5QUVRhUnVtRkJJeThiUTBlWG54NEhnNm92c2FfSmt3WldCZAkpoZAERCYwZDZD')
      .then((res) => res.json())
      .then((data) => {
        setMedia(data.data); 
        setLoading(false); 
      })
      .catch((error) => {
        console.error("Error fetching media:", error);
        setLoading(false); 
      });
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <Container>
        <h2 className="fw-bold" id="instaLinear">Social Media Highlights</h2>
        <p className="fs-18 w-100">
            Follow us on social media for the latest trends and corporate gifting ideas! 
        </p>
      <Row>
        {medias
          .filter((media) => media.media_type !== "VIDEO") // Filter out videos
          .slice(0, 4) 
          .map((media) => (
            <Col md={3} className="col-6 m-auto d-block" key={media.id}>
              <Link to={media.permalink} target="_blank">
              <img
                className="image-responsive w-100 m-2"
                style={{ border: "1px solid #F19121"}}
                src={media.media_url}
                alt={media.caption}
              />
              </Link>
            </Col>
            
          ))}
        
          <Link className="text-decoration-none "  target="_blank"  to="https://www.instagram.com/eyantra_">
            <Button id="btnCTA" className="m-auto d-block mt-4">Visit Our Instagram</Button>
            </Link>
      </Row>
    </Container>
  );
};

export default Instapost;
